export interface PlanFeature {
    text: string;
    included: boolean;
}

export interface Plan {
    code: 'free' | 'pro';
    name: string;
    price: string;
    description: string;
    features: PlanFeature[];
    popular: boolean;
}

export const plans: Plan[] = [
    {
        code: 'free',
        name: 'Gratuit',
        price: '0',
        description:
            "Accédez à l'outil complet et gérez vos revues manuellement, sans limite de temps.",
        features: [
            { text: '1 projet actif', included: true },
            { text: 'Import Zotero, RIS, BibTeX', included: true },
            { text: 'Sélection manuelle des articles', included: true },
            { text: 'Rattachement PDF manuel', included: true },
            { text: "Grille d'extraction manuelle", included: true },
            { text: 'Export CSV, Excel, PRISMA', included: true },
            { text: 'Sélection assistée par l’IA', included: false },
            { text: 'Rattachement PDF automatique (IA)', included: false },
            { text: 'Extraction IA depuis les PDF', included: false },
        ],
        popular: false,
    },
    {
        code: 'pro',
        name: 'Pro',
        price: '29',
        description:
            "Débloquez toute la puissance de l'IA pour accélérer chaque étape de votre revue.",
        features: [
            { text: 'Tout du plan Gratuit', included: true },
            { text: 'Projets illimités', included: true },
            { text: 'Sélection assistée illimitée', included: true },
            { text: 'Rattachement PDF automatique illimité', included: true },
            { text: 'Extraction IA illimitée', included: true },
            { text: 'Support prioritaire par email', included: true },
        ],
        popular: true,
    },
];
